(function(){
  'use strict';
  if(window.SaberFeedbackLoaded)return;
  window.SaberFeedbackLoaded=true;
  function initialize(){
    var page=document.querySelector('[data-feedback-page]');
    if(!page)return;
    var context=page.querySelector('[data-feedback-context]'),list=page.querySelector('[data-feedback-context-list]'),form=page.querySelector('form');
    if(!context||!list||!form)return;
    var params=new URLSearchParams(window.location.search),raw=params.get('product_url');
    if(!raw)return;
    var url;
    try{url=new URL(raw,window.location.origin);}catch(error){return;}
    if(url.origin!==window.location.origin||!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9][a-z0-9-]*\/?$/i.test(url.pathname))return;
    var labels=(page.getAttribute('data-feedback-labels')||'').split('|');
    function text(key,max){return(params.get(key)||'').replace(/[\u0000-\u001f\u007f]/g,'').slice(0,max).trim();}
    function identifier(key){var value=text(key,20);return /^\d{1,20}$/.test(value)?value:'';}
    var variantId=identifier('variant_id'),productId=identifier('product_id');
    url.search=variantId?'?variant='+variantId:'';url.hash='';
    var rows=[{label:labels[0],key:'Product',value:text('product',250)},{label:labels[1],key:'Item / model reference',value:text('sku',180)},{label:labels[2],key:'Option',value:text('variant',150)},{label:labels[3],key:'Product URL',value:url.href,link:true},{key:'Product / variant IDs',value:[productId,variantId].filter(Boolean).join(' / '),hidden:true}];
    rows.forEach(function(row){
      if(!row.value)return;
      var term=document.createElement('dt'),description=document.createElement('dd'),hidden=document.createElement('input');
      term.textContent=row.label||row.key;
      if(row.link){var anchor=document.createElement('a');anchor.href=row.value;anchor.textContent=url.pathname;description.appendChild(anchor);}else{description.textContent=row.value;}
      hidden.type='hidden';hidden.name='contact['+row.key+']';hidden.value=row.value;hidden.setAttribute('data-feedback-product-field','');
      if(!row.hidden){list.appendChild(term);list.appendChild(description);}
      form.appendChild(hidden);
    });
    context.hidden=false;
  }
  document.addEventListener('click',function(event){document.querySelectorAll('.ss-feedback-info[open]').forEach(function(details){if(!details.contains(event.target))details.open=false;});});
  document.addEventListener('toggle',function(event){
    var details=event.target;
    if(!details.matches||!details.matches('.ss-feedback-info')||!details.open)return;
    var explanation=details.querySelector('p'),anchor=details.closest('[data-product-feedback]');
    if(!explanation||!anchor)return;
    explanation.style.top='100%';explanation.style.bottom='auto';
    var bounds=explanation.getBoundingClientRect();
    if(bounds.bottom>window.innerHeight-8&&anchor.getBoundingClientRect().top>bounds.height+8){explanation.style.top='auto';explanation.style.bottom='100%';}
  },true);
  document.addEventListener('keydown',function(event){if(event.key!=='Escape')return;document.querySelectorAll('.ss-feedback-info[open]').forEach(function(details){details.open=false;details.querySelector('summary').focus();});});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
})();
